var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h4',{staticClass:"mb-4"},[_vm._v("Strande")]),_c('v-row',_vm._l((_vm.locations),function(l){return _c('v-col',{key:l.title,attrs:{"cols":"12","md":"6","xl":"4"}},[_c('LocationCard',{attrs:{"l":l}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }